/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';
import { Container } from '@mui/material';

export const ContactUsContainer = styled(Container)`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-top: 5%;
  margin-bottom: 5%;
`;
